import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { Sponsors } from "../../../components/sponsors";
import { AckOverview } from "../../../components/ack-overview";

export interface ICapstoneProps {
    sectionId: string;
    index: number;
}

export function Capstone(props: ICapstoneProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} What is Capstone`}
            />
            <ParagraphGroup
                body={[
                    "Capstone is a seven-month project beginning in the second semester of the Master of Human-Computer Interaction program at Carnegie Mellon University. It provides an opportunity for students to work in teams to tackle a real-world problem sponsored by a real-world client, gaining hands-on experience with applying generative and evaluative user research and design principles."
                ]}
            />
            <Sponsors />
            <AckOverview
                groups={
                    [
                        {
                            groupName: "Clients at PNNL",
                            members: [
                                "Dustin Arendt",
                                "Maria Glenski"
                            ]
                        },
                        {
                            groupName: "PNNL Guests",
                            members: [
                                "Robin Cosbey",
                                "Todd Billow",
                                "Claudia Hilderbrand",
                                "Ellyn Ayton",
                                "Svitlana Volkova",
                                "Sara Mans",
                                "James Bradford",
                                "Lyndsey Franklin",
                                "Todd Thompson"
                            ]
                        },
                        {
                            groupName: "Capstone Advisors",
                            members: [
                                "Anna Abovyan",
                                "Raelin Musuraca"
                            ]
                        },
                        {
                            groupName: "Expert Interviewees",
                            members: [
                                "Haiyi Zhu", 
                                "Kathleen Carley",
                                "David Danks",
                                "Jonathan Brown",
                                "Ken Holstein",
                                "Carol Smith",
                                "Motahhare Eslami",
                                "Erin Malone",
                                "Geoff Kaufman"
                            ]
                        }
                    ]
                }
            />
        </Section>
    );
}
